import { FC } from "react";

import { User, Mail, Band, IdCard, Weight, Key } from "shared/assets/icons";
import { SideMenu } from "shared/components";
import { ISideMenuItem } from "shared/components/SideMenu/types";
import { buildUrl } from "shared/utils";
import { copy } from "shared/assets";

import { useProfileContext } from "Auth/contexts";
import { BAND_PATHS } from "Bands/router";

const {
  profile: { sidemenu, profileIds },
} = copy;

export const ProfileSideMenu: FC = () => {
  const { userName } = useProfileContext();

  const items: ISideMenuItem[] = [
    {
      id: "personal",
      title: sidemenu.personal,
      path: buildUrl(BAND_PATHS.PROFILE, {}, profileIds.personal),
      icon: User,
    },
    {
      id: "contact",
      title: sidemenu.contact,
      path: buildUrl(BAND_PATHS.PROFILE, {}, profileIds.contact),
      icon: Mail,
    },
    {
      id: "documents",
      title: sidemenu.documents,
      path: buildUrl(BAND_PATHS.PROFILE, {}, profileIds.documents),
      icon: IdCard,
    },
    {
      id: "preferences",
      title: sidemenu.preferences,
      path: buildUrl(BAND_PATHS.PROFILE, {}, profileIds.preferences),
      icon: Weight,
    },
    {
      id: "bands",
      title: sidemenu.bands,
      path: buildUrl(BAND_PATHS.PROFILE, {}, profileIds.bands),
      icon: Band,
    },
    {
      id: "api-keys",
      title: sidemenu.apiKeys,
      path: buildUrl(BAND_PATHS.PROFILE, {}, profileIds.apiKeys),
      icon: Key,
    },
  ];

  return <SideMenu title={userName} titleUrl={BAND_PATHS.PROFILE} items={items} />;
};
